import React, { Component } from 'react';
import { Select, Space } from 'antd';

import AppHelper from 'libs/AppHelper';

export default class StockStore extends Component {
  state = {
    query: {
      city_id: null,
      area_id: null,
    },
  };

  handleChange = (value, queryKey) => {
    const stateQuery = { ...this.state.query };
    stateQuery[queryKey] = !isNaN(value) ? value : null;
    if (queryKey === 'city_id') {
      stateQuery.area_id = null;
    }
    this.setState({ query: stateQuery });
    AppHelper.getStoreList(stateQuery);
  };

  render() {
    const configOptions = this.props.app.options || {};
    const cityListAll = configOptions.citys || [];
    const storeListAll = configOptions.stores || [];
    const query = this.state.query || {};
    const selectedCityId = query.city_id;

    const cityListAvailable = [
      ...new Set(storeListAll.map((storeInfo) => storeInfo['store_city_name'])),
    ];

    const cityList = cityListAll
      .filter((obj) => cityListAvailable.indexOf(obj.name) > -1)
      .map((obj) => {
        return { ...obj, value: obj.id, label: obj.name };
      });
    const citySelected =
      cityList.filter((obj) => obj.value === selectedCityId) || [];

    const areaListSelected =
      citySelected.length > 0
        ? [
            ...new Set(
              storeListAll
                .filter((obj) => {
                  return (
                    obj['store_city_name'] === citySelected[0].name &&
                    obj['status_name'] !== '停用'
                  );
                })
                .map((obj) => obj['store_area_name'])
            ),
          ]
        : [];

    const areaList =
      citySelected.length > 0
        ? citySelected[0].children
            .filter((obj) => areaListSelected.indexOf(obj.name) > -1)
            .map((obj) => {
              return { value: obj.id, label: obj.name };
            })
        : [];

    return (
      <Space wrap>
        <Select
          placeholder='請選擇縣市'
          style={{ width: '112px' }}
          onChange={(e) => this.handleChange(e, 'city_id')}
          options={cityList}
        />
        <Select
          placeholder='請選擇區域'
          value={query.area_id}
          style={{ width: '112px' }}
          disabled={query.city_id === null}
          onChange={(e) => this.handleChange(e, 'area_id')}
          options={areaList}
        />
      </Space>
    );
  }
}

// 編輯器
export class StockStoreEditor extends Component {
  formRef = React.createRef();

  render() {
    return (
      <div className='vu-blocks-editor'>
        <h5>門市選擇器</h5>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/blocks/stock/stock-store.js